import './_rollupPluginBabelHelpers-a38db067.js';
import './styled-system/utils.js';
import './styled-system/core/core-utils.js';
import './styled-system/core/parser.js';
import './styled-system/core/compose.js';
import './styled-system/core/style-function.js';
import './styled-system/core/system.js';
import './styled-system/parsers/typography.js';
import './styled-system/parsers/transition.js';
import './styled-system/parsers/margin.js';
import './styled-system/parsers/padding.js';
import './styled-system/parsers/space.js';
import './styled-system/parsers/shadow.js';
import './styled-system/parsers/animation.js';
import './styled-system/parsers/background.js';
import './styled-system/parsers/border.js';
import './styled-system/parsers/color.js';
import './styled-system/parsers/flexbox.js';
import './styled-system/parsers/grid.js';
import './styled-system/parsers/layout.js';
import './styled-system/parsers/other.js';
import './styled-system/parsers/position.js';
import './styled-system/parsers/parsers-config.js';
import './styled-system/parsers/pseudo.js';
import './styled-system/css/css-utils.js';
import './styled-system/css/index.js';
import 'styled-components';
import { styled } from './create-styled.js';

/**
 * Creates a styled element of a specified type with optional props.
 *
 * @template ElementPropsType - The type of props for the styled element.
 * @param type - The type of the HTML element to style.
 * @returns A styled element of the specified type.
 */
const createStyledElement = type => {
  return styled(type)``;
};

export { createStyledElement };
